import PropTypes from 'prop-types';
import React from 'react';
import { useActions, useValues } from 'kea';

import assetlogic from 'src/store/asset';

import AssignGroupDialog from './AssignGroupDialog';
import EditAssetDialog from './EditAssetDialog';
import checkRole from 'src/utils/checkRole';

import profilelogic from 'src/store/profile';

const ActionButtons = ({ row }) => {

	const { update, updateGroup } = useActions(assetlogic);

	const { profile } = useValues(profilelogic);

	const handle_edit = (existing_asset) => {
		update(existing_asset);
	}

	const handle_group = (existing_asset) => {
		updateGroup(existing_asset);
	}



	return (
		<div style={{ display: 'flex', flexGrow: 1 }}>
			{checkRole(profile, ['AssetEdit']) && <EditAssetDialog asset={row} OnEditAsset={handle_edit} />}
			{checkRole(profile, ['Admin']) && <AssignGroupDialog asset={row} onGroupAssign={handle_group} />}
			{/* <SIMDialog asset={row} OnSIMStatus={handle_sim_status} /> */}
			{/* <RemoveAssetDialog OnRemoveAsset={handle_remove} /> */}
		</div>
	);
};

ActionButtons.propTypes = {
	row: PropTypes.object.isRequired
};

export default ActionButtons;
